<template>
  <v-dialog
    v-model="dialog"
    persistent
    max-width="500"
  >
    <template v-slot:activator="{ on }">
      <v-btn 
        icon 
        x-small
        v-on="on"
      >
        <v-icon color="primary">
          mdi-pencil
        </v-icon>
      </v-btn>
    </template>
    
    <material-card
      :offset="10"
      :full-width="true"
      color="hrissecondary"
      title="Superior"
      text="Update superior"
      class="mb-0"
      :loading="loading"
    >
      <form v-if="dialog && !loading">
        <v-container>
          <v-row>
            <v-col
              cols="12"
              class="pb-0"
            >
              <v-autocomplete
                v-model="newSuperior"
                v-validate="'required'"
                label="New Superior"
                :items="employees"
                :error-messages="errors.collect('newSuperior')"
                data-vv-name="newSuperior"  
                data-vv-as="new superior"  
                item-text="person.name"
                item-value="employee_uid"
                outlined
              /> 
            </v-col>

            <v-col
              cols="12"
              class="pb-0"
            >
              <v-menu
                v-model="effectiveDateMenu"
                :close-on-content-click="false"
                :nudge-right="40"
                transition="scale-transition"
                offset-y
                min-width="290px"
              >
                <template v-slot:activator="{ on }">
                  <v-text-field
                    v-model="effectiveDate"
                    v-validate="'required'"
                    label="Effective Date"
                    :error-messages="errors.collect('effectiveDate')"
                    data-vv-name="effectiveDate"  
                    data-vv-as="effective date"      
                    readonly
                    class="fix-date-picker-outline-overlap"
                    outlined
                    v-on="on"
                  >
                    <template v-slot:prepend-inner>
                      <v-icon>
                        mdi-calendar
                      </v-icon>
                    </template>
                  </v-text-field>
                </template>
                <v-date-picker
                  v-model="effectiveDate"
                  @input="effectiveDateMenu = false"
                />
              </v-menu>
              <p
                v-if="$moment(effectiveDate).diff($moment()) >= 0"
                class="warning--text"
              >
                By selecting a future date, the details will only save when it reach the date
              </p>
            </v-col>
          </v-row>
        </v-container>
      </form> 

      <v-card-actions v-if="dialog && !loading">
        <v-spacer />
        <v-btn
          :disabled="progressing"
          text
          class="px-10"
          @click="dialog = false"
        >
          Cancel
        </v-btn>
        <v-btn
          :loading="progressing"
          color="hrissecondary"    
          class="white--text px-10"      
          @click="submitForm"
        >
          Update
        </v-btn>
      </v-card-actions> 
    </material-card>  
  </v-dialog>
</template>

<script>
  export default {
    $_veeValidate: {
      validator: 'new', 
    },
    props: {
      employeeUid: {
        type: String,
        required: true,
      },
    },
    data () {
      return {
        dialog: false,
        progressing: false,
        loading: false,
        employees: [],
        newSuperior: null,
        effectiveDateMenu: null,
        effectiveDate: null,
      }
    },
    watch: {
      dialog: function (value) {
        if (!value) return this.$resetData()

        this.loading = true

        this.$api.hrisEmployees().list('?with=vessel')
          .then(res => {
            this.employees = res.data.filter(employee => {
              return employee.employee_uid !== this.employeeUid
            })
            this.employees = _.orderBy(res.data, ['person.name'], ['asc'])

            this.loading = false
          })
      },
    },
    methods: { 
      submitForm () {
        this.$validator.validateAll()
          .then(result => {
            if (!result) return

            this.setProgressing(true)

            this.$api.hrisReportTo().create(this.employeeUid, this.prepareFormData())
              .then(response => {
                if (response.status === 200 || response.status === 201) {
                  this.$emit('updated')
                  this.$snack({ message: 'Employee superior updated' })
                }
              }).catch(error => {
                if (error.response.status === 405) {
                  this.$dialog({
                    title: 'Unable to change superior',
                    message: error.response.data.message, 
                    color: 'error',
                  })
                }
              }).then(() => {
                this.setProgressing(false)
                this.dialog = false
              })
          })
      },
      setProgressing (status) {
        this.progressing = status
      },
      prepareFormData () {
        return {
          assigned_to: this.newSuperior,
          new: false,
          effective_date: this.effectiveDate,
        }
      },
    
    },
  }
</script>

<style scoped>
.fix-date-picker-outline-overlap >>> label{
  background: white;
  padding-right:10px
}
</style>
